import React from 'react';
import './App.css';
import {Styles} from "./Styles/Styles";
import {GlobalSettingsProvider} from "./Provider/useGlobalSettings";
import {Routing} from "./Routing";
import {WebSocketServer} from "./Provider/useWebSocketServer";
import {SquadProvider} from "./Provider/useSquad";
import {VoiceSocketServer} from "./Provider/useVoiceSocketServer";
import {IndustrialTaskProvider} from "./Provider/useIndustrialTasks";

function App() {
  return (
    <Styles.Init className="App">
        <GlobalSettingsProvider>
            <WebSocketServer>
                <VoiceSocketServer>
                    <IndustrialTaskProvider>
                        <SquadProvider>
                            <Routing />
                        </SquadProvider>
                    </IndustrialTaskProvider>
                </VoiceSocketServer>
            </WebSocketServer>
        </GlobalSettingsProvider>
    </Styles.Init>
  );
}

export default App;
